import axiosInstance from '../utils/axiosInstance';
import type { AudioLanguage } from '../audio-transcription/createAudioTranscription';

const ENDPOINT = '/user-preferences';

export interface UserPreferencesResponse {
  data: {
    favoriteModels: string[];
    // null when the user has never saved a choice → caller falls back to DEFAULT_AUDIO_LANGUAGE.
    audioLanguage: AudioLanguage | null;
  };
}

export interface UpdateUserPreferencesInput {
  favoriteModels?: string[];
  audioLanguage?: AudioLanguage;
}

export async function getUserPreferences(): Promise<UserPreferencesResponse> {
  const response = await axiosInstance.get(ENDPOINT);
  const stored = response?.data?.data?.audioLanguage;
  const audioLanguage: AudioLanguage | null =
    stored === 'af' || stored === 'en' ? stored : null;
  // favoriteModels is not persisted server-side yet; kept on the response shape
  // for back-compat with existing consumers (always [] until a backend stores it).
  return { data: { favoriteModels: [], audioLanguage } };
}

export async function updateUserPreferences(prefs: UpdateUserPreferencesInput): Promise<void> {
  // Only audioLanguage is persisted server-side today. favoriteModels has no
  // backend store, so passing it is a no-op rather than an error.
  if (prefs.audioLanguage !== undefined) {
    await axiosInstance.put(ENDPOINT, { audioLanguage: prefs.audioLanguage });
  }
}
